import { create } from "zustand";

const qcAtkingCityIdsStore = create((set, get) => ({
  cityIds: {}, // Lưu trữ tất cả các player và config của họ
  setCityId: (playerId, newCityId) => {
    if (get().cityIds[playerId] === newCityId) {
      return;
    }
    set((state) => ({
      cityIds: {
        ...state.cityIds,
        [playerId]: newCityId
      }
    }))
  }
}));

export default qcAtkingCityIdsStore;
